/** @jsxImportSource @emotion/react */
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../../../components/button/button.component';
import { Notification } from '../../../../components/notification/notification.component';

interface PropTypes {
    showChargingLimit: boolean;
    setShowChargingLimit: (value: boolean) => void;
    isCarConnected: boolean;
    onSetSetUpStep: (state: { disableSessionLimit: boolean }) => void;
    amount?: number;
    currency: string;
    isCreatingTransaction?: boolean;
    isUnavailable: boolean;
}

export const SecurityDeposit: React.FC<PropTypes> = ({
    showChargingLimit,
    setShowChargingLimit,
    isCarConnected,
    onSetSetUpStep,
    amount,
    currency,
    isCreatingTransaction,
    isUnavailable,
}) => {
    const intl = useIntl();

    return (
        <>
            <Button
                type="link"
                onClick={() => setShowChargingLimit(!showChargingLimit)}
                text={intl.formatMessage({
                    id: showChargingLimit ? 'removeChargingLimit' : 'addChargingLimit',
                })}
                styles={{
                    color: '#004FC6',
                    fontWeight: 600,
                    fontSize: '15px',
                    padding: '16px 0',
                    width: '100%',
                    textAlign: 'center',
                    marginBottom: '12px',
                    ...(showChargingLimit ? {} : { marginTop: '12px' }),
                }}
            />
            {!showChargingLimit && (
                <>
                    <div style={{ marginTop: 8, marginBottom: 8 }}>
                        <Button
                            isLoading={isCreatingTransaction}
                            disabled={!isCarConnected || isCreatingTransaction || isUnavailable}
                            text={intl.formatMessage({ id: 'next' })}
                            onClick={() => onSetSetUpStep({ disableSessionLimit: true })}
                        />
                    </div>
                    <Notification
                        text={intl.formatMessage(
                            { id: 'securityDeposit.notification' },
                            {
                                amount: amount ? (amount / 100).toFixed(2) : '0.00',
                                currency,
                            }
                        )}
                    />
                </>
            )}
        </>
    );
};
